export function validTagOrAttributeCategory(category) {
  return /^[a-zA-Z0-9_]{3,50}$/.test(category)
}

export function validName(name) {
  return /^[A-Za-z0-9_\-\s]{3,50}$/.test(name)
}
